module.exports = __webpack_public_path__ + "img/zhuangtai.449fd498.png";